import emailjs from '@emailjs/browser';

function check(str) {
    const reg = new RegExp("^[a-z0-9]+([._\\\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$")
    return reg.test(str)
}

function send(emailAddress, company, massage) {
    emailjs.init("6bQfziKJcfVZt5ErT");
    const templateParams = {emailAddress, company, massage}
    return new Promise((resolve, reject) => {
        emailjs.send('service_xrm58p7', 'template_5atop7e', templateParams).then(res => {
            console.log(res, '--------------')
            resolve(res)
        }, (error) => {
            console.log('FAILED...', error);
            reject(error)
        });
    })
}

export default {
    check,
    send
}